import Icon from '@/components/snippets/icon/icon'
import { FilterDrawer } from 'libs/searchspring/components/collection/filters/FilterDrawer'

export const SearchToolbar = ({ query, totalResults, corrections, showFilters, loading }) => {
  const displayedQuery = corrections?.corrected || query || ''

  let titleText
  if (loading) {
    titleText = displayedQuery
      ? `Searching for "${displayedQuery}"`
      : 'Searching...'
  } else {
    const countLabel = totalResults === 0 ? 'No' : totalResults.toLocaleString()
    titleText = `${countLabel} Results for "${displayedQuery}"`
  }

  return (
    <div className="collection-toolbar flex sticky top-header-adapt left-0 w-full z-40 transition-all">
      <div className="grid grid-cols-full-min gap-x-1 items-center w-full min-h-[56px] lg:min-h-[55px] bg-secondary px-margin border-b border-borders-default">
        <div className="col-[1/2] flex items-center gap-x-1 min-w-0">
          <div className="py-1">
            <div className="lg:pr-1 lg:border-r lg:border-borders-default">
              <h2 className="paragraph-m font-serif italic">
                {titleText}
              </h2>
            </div>
          </div>
          <div className="lg-max:hidden">
            <x-button class="btn btn-text btn-primary btn-m w-fit" data-modal-parent="quick-search" data-modal-role="open" aria-label="Search Again">
              <div className="flex size-[13px] children:size-full">
                <Icon id="magnifying-glass" />
              </div>
              <span>
                Search<span className="hidden md:inline"> Again</span>
              </span>
            </x-button>
          </div>
        </div>
        <div className="shrink-0 col-[2/3] flex lg:items-end lg:justify-end py-0.25">
          {loading ? (
            <div className="flex items-center w-[106.01px] h-[44px] animate-pulse">
              <div className="w-full h-[12px] bg-type-white-secondary"></div>
            </div>
          ) : (
            <x-button
              class="btn btn-text btn-primary btn-m w-fit whitespace-nowrap"
              data-modal-parent="filters"
              data-modal-role="toggle"
              aria-label="Filter & Sort"
            >
              <span>Filter & Sort</span>
              <div className="flex size-[11px] children:size-full">
                <Icon id="plus" />
              </div>
            </x-button>
          )}
        </div>
      </div>
      <FilterDrawer showFilters={showFilters} />
    </div>
  )
}
